		let data = {table_headers: [], data: []};
        data.module = {id: 'breach', display: 'Incident Register'}
		data.table_headers = [
            {
                accessor: "status", nickname: "Status", type: "alpha", width: 0.91,
                "valign": {'top':false,'vcentred':true,'bottom':false}, 
                "halign":{'left':true,'hcentred':false, 'right':false}
            },
            {
                accessor: "breachid", nickname: "ID", type: "alpha", width: 1,
                "valign": {'top':false,'vcentred':true,'bottom':false}, 
                "halign":{'left':true,'hcentred':false, 'right':false}
            },
            {
                accessor: "breach_type", nickname: "Type", type: "alpha", width: 1.34,
                "valign": {'top':false,'vcentred':true,'bottom':false}, 
                "halign":{'left':true,'hcentred':false, 'right':false}
            },
            {
                accessor: "incident_title", nickname: "Incident", type: "alpha", width: 2.9,
                "valign": {'top':false,'vcentred':true,'bottom':false}, 
                "halign":{'left':true,'hcentred':false, 'right':false}
            },
            {
                accessor: "isreportable", nickname: "Reportable", type: "alpha", width: 0.85,
                "valign": {'top':false,'vcentred':true,'bottom':false}, 
                "halign":{'left':false,'hcentred':true, 'right':false}
            },
            {
                accessor: "no_of_followup", nickname: "Tasks", type: "numeric", width: 0.49,
                "valign": {'top':false,'vcentred':true,'bottom':false}, 
                "halign":{'left':false,'hcentred':true, 'right':false}
            },
            {
                accessor: "incident_date", nickname: "Incident Date", type: "date", width: 0.75,
                "valign": {'top':false,'vcentred':true,'bottom':false}, 
                "halign":{'left':true,'hcentred':false, 'right':false}
            },
            {
                accessor: "closed_date", nickname: "Closed Date", type: "date", width: 0.75,
                "valign": {'top':false,'vcentred':true,'bottom':false}, 
                "halign":{'left':true,'hcentred':false, 'right':false}
            }
        ];

        data.sortby = {
            fields: [
                {accessor: "status", nickname: "Status", type: "alpha", width: 1.2},
                {accessor: "breachid", nickname: "ID", type: "alpha", width: 1.3},
                {accessor: "breach_type", nickname: "Type", type: "alpha", width: 1.5},
                {accessor: "incident_title", nickname: "Incident", type: "alpha", width: 2},
                {accessor: "isreportable", nickname: "Reportable", type: "alpha", width: 1.4},
                {accessor: "no_of_followup", nickname: "Tasks", type: "numeric", width: 0.8},
                {accessor: "incident_date", nickname: "Incident Date", type: "numeric", width: 1.1},
                {accessor: "closed_date", nickname: "Closed Date", type: "numeric", width: 1.1},
            ],
            selected: {"accessor": "none", "order": "Descending"}
        };
        data.groupby = {
            fields: [
                {accessor: "status", nickname: "Status", type: "alpha", width: 1.2},
                {accessor: "breachid", nickname: "ID", type: "alpha", width: 1.3},
                {accessor: "breach_type", nickname: "Type", type: "alpha", width: 1.5},
                {accessor: "incident_title", nickname: "Incident", type: "alpha", width: 2},
                {accessor: "isreportable", nickname: "Reportable", type: "alpha", width: 1.4},
                {accessor: "no_of_followup", nickname: "Tasks", type: "numeric", width: 0.8},
                {accessor: "incident_date", nickname: "Incident Date", type: "numeric", width: 1.1},
                {accessor: "closed_date", nickname: "Closed Date", type: "numeric", width: 1.1},
            ],
            selections: []
        };
        data.font_size_map = {
            section_titles :    {default : {selected : false, size : 16}, small : {selected : false, size : 14}, large : {selected : true, size : 18}},
            introductory_text : {default : {selected : false, size : 12}, small : {selected : false, size : 11}, large : {selected : true, size : 14}},
            header_row_text :   {default : {selected : true, size : 12}, small : {selected : false, size : 11}, large : {selected : false, size : 14}},
            table_data_text :   {default : {selected : true, size : 11}, small : {selected : false, size : 10}, large : {selected : false, size : 12}},       
            footer:             {default : {selected : true, size : 10}, small : {selected : false, size : 9}, large : {selected : false, size : 11}}
        }

module.exports = data